import styled from "styled-components";
import { shadows } from "@evergis/ui";
import { Map } from "@evergis/react";

export const StyledMap = styled(Map)`
  height: 100%;
  width: 100%;
  position: relative;
`;

export const MapControlTool = styled.div`
  z-index: 1;
  position: relative;
  display: flex;
  height: 2.5rem;
  margin-right: 0.5rem;
  box-sizing: border-box;
  box-shadow: ${shadows.raised};
  color: ${({ theme: { palette } }) => palette.textPrimary};

  :after {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: ${({ theme: { palette } }) => palette.panelBackground};
    backdrop-filter: blur(10px);
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
  }
`;
